"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8598],{

/***/ 13866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(14564);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(86886);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59242);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68720);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56721);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(99842);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(61659);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(74030);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79967);
/* harmony import */ var _utils_filtersStorage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85627);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);
/* harmony import */ var _hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89698);
/* harmony import */ var _contexts_SegmentationFiltersContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99207);
















var LocationFilter = function() {
    var ref = (0,_care_react_component_lib__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(), isEmbraceTheme = ref.isEmbraceTheme, isCareTheme = ref.isCareTheme;
    var ref1 = (0,_contexts_SegmentationFiltersContext__WEBPACK_IMPORTED_MODULE_6__/* .useSegmentationFiltersContext */ .RZ)(), filters = ref1.filters, setFilters = ref1.setFilters, fetchResults = ref1.fetchResults;
    var userGeoInfo = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)().userGeoInfo;
    var ref2 = (0,_hooks_useZipCodeValidation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), validate = ref2.validate, hasError = ref2.hasError;
    var localStorageFilters = (0,_utils_filtersStorage__WEBPACK_IMPORTED_MODULE_8__/* .loadFilters */ .dm)();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), anchorEl = ref3[0], setAnchorEl = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), zipCodeInput = ref4[0], setZipCodeInput = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), cityInput = ref5[0], setCityInput = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), stateInput = ref6[0], setStateInput = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), savedCity = ref7[0], setSavedCity = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), savedState = ref8[0], setSavedState = ref8[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var fetchGeoInfo = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                var ref, zipMatch, prefillZip, data;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            zipMatch = (ref = userGeoInfo === null || userGeoInfo === void 0 ? void 0 : userGeoInfo.match(/zip=(\d{5})/)) === null || ref === void 0 ? void 0 : ref[1];
                            prefillZip = zipMatch;
                            setZipCodeInput(prefillZip);
                            return [
                                4,
                                validate(prefillZip)
                            ];
                        case 1:
                            data = _state.sent();
                            setCityInput(data === null || data === void 0 ? void 0 : data.city);
                            setStateInput(data === null || data === void 0 ? void 0 : data.state);
                            if (!filters) {
                                setFilters({
                                    location: {
                                        zipcode: prefillZip,
                                        city: data === null || data === void 0 ? void 0 : data.city,
                                        state: _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .UsStateCode */ .y9[data === null || data === void 0 ? void 0 : data.state]
                                    }
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchGeoInfo() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchGeoInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (filters) {
            var location = filters.location;
            if (location) {
                setZipCodeInput((location === null || location === void 0 ? void 0 : location.zipcode) || "");
                setCityInput((location === null || location === void 0 ? void 0 : location.city) || "");
                setStateInput((location === null || location === void 0 ? void 0 : location.state) || "");
                setSavedCity((location === null || location === void 0 ? void 0 : location.city) || "");
                setSavedState((location === null || location === void 0 ? void 0 : location.state) || "");
            }
        }
    }, [
        filters
    ]);
    var onChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(event) {
            var value, data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = event.target.value;
                        setSavedCity("");
                        setSavedState("");
                        if (value.length > 5) return [
                            2
                        ];
                        setZipCodeInput(value);
                        if (!(value.length <= 5)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validate(value)
                        ];
                    case 1:
                        data = _state.sent();
                        setCityInput((data === null || data === void 0 ? void 0 : data.city) || "");
                        setStateInput((data === null || data === void 0 ? void 0 : data.state) || "");
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClick = function(event) {
        setAnchorEl(event.currentTarget);
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.clickOnSegmentationFilter */ .Sj.clickOnSegmentationFilter, {
            zipCode: zipCodeInput
        });
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var handleApplyClick = function() {
        var ref;
        var resetPage = zipCodeInput === "" || zipCodeInput !== (filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode);
        var updatedFilters = {
            zipcode: zipCodeInput
        };
        if (localStorageFilters) {
            updatedFilters = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, localStorageFilters), {
                zipcode: zipCodeInput
            });
        }
        fetchResults(updatedFilters, resetPage);
        setAnchorEl(null);
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.applySegmentationFilter */ .Sj.applySegmentationFilter, {
            zipCode: zipCodeInput
        });
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter") {
            handleApplyClick();
        }
    };
    var getHelperText = function() {
        if (hasError) return "Enter a valid ZIP code (e.g. “02453”)";
        if (zipCodeInput && savedCity && savedState) {
            return "".concat(savedCity, ", ").concat(savedState);
        }
        if (zipCodeInput && cityInput && stateInput) {
            return "".concat(cityInput, ", ").concat(stateInput);
        }
        return "";
    };
    var getDisplayText = function() {
        if (savedCity && savedState) {
            return "".concat(savedCity, ", ").concat(savedState);
        }
        if (zipCodeInput && cityInput && stateInput) {
            return "".concat(cityInput, ", ").concat(stateInput);
        }
        return "City, State";
    };
    var open = Boolean(anchorEl);
    var showDisplay = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Boolean(savedCity && savedState) || Boolean(zipCodeInput && cityInput && stateInput);
    }, [
        savedCity,
        savedState,
        zipCodeInput,
        cityInput,
        stateInput
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        mb: {
            xs: 3,
            sm: 6
        },
        mr: 3,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                "aria-describedby": "location-filter",
                color: isEmbraceTheme ? "primary" : "secondary",
                variant: "outlined",
                onClick: handleClick,
                size: isEmbraceTheme ? "small" : "medium",
                sx: function(theme) {
                    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, isCareTheme && {
                        minWidth: "252px",
                        height: "48px",
                        borderRadius: 4,
                        borderColor: theme.palette.care.grey[300]
                    }, isEmbraceTheme && {
                        minWidth: "252px"
                    });
                },
                startIcon: isEmbraceTheme ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {}),
                endIcon: isEmbraceTheme ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    variant: "body3",
                    sx: function(theme) {
                        return {
                            flex: 1,
                            textAlign: "left",
                            fontSize: "1.125rem",
                            fontWeight: showDisplay ? 700 : 400,
                            color: showDisplay ? undefined : theme.palette.care.grey[500]
                        };
                    },
                    children: getDisplayText()
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .ZP, {
                id: "location-filter",
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                sx: function(theme) {
                    return {
                        "& .MuiPaper-root": {
                            minWidth: "100px",
                            borderRadius: "24px",
                            border: "1px solid ".concat(theme.palette.care.grey[300]),
                            marginTop: theme.spacing(1),
                            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.15);",
                            padding: theme.spacing(3, 2),
                            maxWidth: "375px",
                            width: "252px"
                        },
                        "& .MuiLink-root": {
                            textAlign: "right"
                        }
                    };
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                id: "locationFilter-zipCode",
                                name: "locationFilter-zipCode",
                                label: "ZIP code",
                                type: "number",
                                value: zipCodeInput,
                                error: hasError,
                                helperText: getHelperText(),
                                onKeyUp: handleKeyUp,
                                onChange: onChange,
                                sx: {
                                    paddingBottom: "16px",
                                    // removes number arrows from Chrome, Safari, Edge, Opera
                                    "& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
                                        appearance: "none",
                                        margin: 0
                                    },
                                    // removes number arrows from Firefox
                                    "& input[type=number]": {
                                        appearance: "textfield"
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .ZP, {
                            item: true,
                            xs: 12,
                            textAlign: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                color: "secondary",
                                variant: "contained",
                                onClick: handleApplyClick,
                                disabled: (zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.length) > 0 && (zipCodeInput === null || zipCodeInput === void 0 ? void 0 : zipCodeInput.length) < 5 || hasError,
                                children: "Apply"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LocationFilter);


/***/ }),

/***/ 35129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46237);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87688);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19957);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98820);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96373);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54743);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);










var Carousel = function(param) {
    var children = param.children, _controlVariant = param.controlVariant, controlVariant = _controlVariant === void 0 ? "none" : _controlVariant, _showProgressIndicator = param.showProgressIndicator, showProgressIndicator = _showProgressIndicator === void 0 ? false : _showProgressIndicator, _itemGap = param.itemGap, itemGap = _itemGap === void 0 ? 3 : _itemGap, _itemsPerView = param.itemsPerView, itemsPerView = _itemsPerView === void 0 ? 3 : _itemsPerView, slotProps = param.slotProps;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var originalSlides = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
    var totalSteps = originalSlides.length;
    var slides = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides));
    var gapInPixels = parseInt(theme.spacing(itemGap), 10);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(totalSteps), currentSlide = ref[0], setCurrentSlide = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isTransitioning = ref1[0], setIsTransitioning = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), slideOffset = ref2[0], setSlideOffset = ref2[1];
    var touchStartX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var touchEndX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!containerRef.current) return undefined;
        var resizeObserver = new ResizeObserver(function(entries) {
            var ref;
            var containerWidth = entries[0].contentRect.width;
            var itemWidth = (containerWidth - (itemsPerView - 1) * gapInPixels) / itemsPerView;
            (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.style.setProperty("--item-width", "".concat(itemWidth, "px"));
            setSlideOffset(itemWidth + gapInPixels);
        });
        resizeObserver.observe(containerRef.current);
        return function() {
            return resizeObserver.disconnect();
        };
    }, [
        itemsPerView,
        gapInPixels
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isTransitioning) return undefined;
        var timer = setTimeout(function() {
            setIsTransitioning(false);
            // When we reach the third set, jump back to equivalent position in second set
            if (currentSlide >= totalSteps * 2) {
                setCurrentSlide(currentSlide - totalSteps);
            }
            // When we reach the first set, jump to equivalent position in second set
            if (currentSlide < totalSteps) {
                setCurrentSlide(currentSlide + totalSteps);
            }
        }, 300);
        return function() {
            clearTimeout(timer);
        };
    }, [
        currentSlide,
        isTransitioning,
        totalSteps
    ]);
    var amplitudeEventButtonClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, {
            feature_name: "Rotate Article Carousel"
        });
    };
    var goToNextSlide = function() {
        if (isTransitioning) {
            return;
        }
        setIsTransitioning(true);
        amplitudeEventButtonClick();
        setCurrentSlide(function(curr) {
            var newSlide = curr + 1;
            return newSlide;
        });
    };
    var goToPrevSlide = function() {
        if (isTransitioning) {
            return;
        }
        setIsTransitioning(true);
        amplitudeEventButtonClick();
        setCurrentSlide(function(curr) {
            var newSlide = curr - 1;
            return newSlide;
        });
    };
    var handleTouchStart = function(e) {
        touchStartX.current = e.touches[0].clientX;
    };
    var handleTouchEnd = function(e) {
        var ref;
        var ref1;
        var endX = (ref1 = (ref = e.changedTouches[0]) === null || ref === void 0 ? void 0 : ref.clientX) !== null && ref1 !== void 0 ? ref1 : 0;
        if (Math.abs(touchStartX.current - endX) > 50) {
            if (touchStartX.current - endX > 0) {
                goToNextSlide();
            } else {
                goToPrevSlide();
            }
        }
        touchStartX.current = 0;
        touchEndX.current = 0;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        display: "flex",
        alignItems: "center",
        children: [
            controlVariant === "sides" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mr: 5,
                zIndex: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    onClick: goToPrevSlide,
                    size: "small",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ref: containerRef,
                sx: {
                    "--item-width": "auto",
                    position: "relative",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        onTouchStart: handleTouchStart,
                        onTouchEnd: handleTouchEnd,
                        sx: {
                            display: "flex",
                            overflow: "hidden",
                            width: "100%"
                        }
                    }, slotProps), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                transform: "translateX(-".concat(currentSlide * slideOffset, "px)"),
                                transition: isTransitioning ? "transform 0.3s ease-in-out" : "none"
                            },
                            children: slides.map(function(slide, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    "aria-hidden": index < currentSlide || index > currentSlide + itemsPerView - 1,
                                    sx: {
                                        width: "var(--item-width)",
                                        flexShrink: 0,
                                        mr: index === slides.length - 1 ? 0 : itemGap,
                                        "& img": {
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "cover",
                                            display: "block",
                                            maxWidth: "100%",
                                            aspectRatio: "3/2"
                                        },
                                        p: 1
                                    },
                                    children: slide
                                }, "carousel-slide-".concat(index + 1));
                            })
                        })
                    })),
                    controlVariant === "topRight" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "flex-end",
                            position: "absolute",
                            top: "-85px",
                            right: "0",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                sx: {
                                    mr: 2
                                },
                                onClick: goToPrevSlide,
                                size: "large",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                onClick: goToNextSlide,
                                size: "large",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                            })
                        ]
                    }),
                    showProgressIndicator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            mt: {
                                xs: 2,
                                md: 6
                            },
                            "& ul .dot": {
                                height: "5px"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            stepNumber: currentSlide % totalSteps + 1,
                            totalSteps: totalSteps
                        })
                    })
                ]
            }),
            controlVariant === "sides" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ml: 5,
                zIndex: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    onClick: goToNextSlide,
                    size: "small",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                })
            })
        ]
    });
};


/***/ }),

/***/ 99207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ SegmentationFiltersContext; },
/* harmony export */   "RZ": function() { return /* binding */ useSegmentationFiltersContext; }
/* harmony export */ });
/* unused harmony export filtersCtx */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var filtersCtx = {
    filters: {
        __typename: "SEOSegmentationFilters",
        location: {
            __typename: "SEOLocationFilters",
            zipcode: "",
            city: "",
            state: null
        }
    },
    setFilters: function(_filters, _reset) {},
    fetchResults: function(_filterVals, _resetPage) {}
};
var SegmentationFiltersContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(filtersCtx);
var useSegmentationFiltersContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SegmentationFiltersContext);
};


/***/ }),

/***/ 89698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useZipCodeValidation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(63357);
;// CONCATENATED MODULE: ./src/API/seoSegmentationValidateZipCode.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query validateZipCode($input: SEOValidateZipCodeInput!) {\n    seoSegmentationValidateZipCode(input: $input) {\n      ... on SEOValidateZipCodeSuccess {\n        __typename\n        city\n        state\n      }\n      ... on SEOValidateZipCodeError {\n        __typename\n        error {\n          message\n          ... on DataNotAvailableError {\n            message\n          }\n          ... on DataNotAvailableForGivenPageNumberError {\n            message\n          }\n          ... on UrlNotFoundError {\n            message\n          }\n          ... on InvalidSEOZipCodeError {\n            message\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var VALIDATE_ZIP_CODE = (0,lib/* gql */.Ps)(_templateObject());
/* harmony default export */ var seoSegmentationValidateZipCode = (VALIDATE_ZIP_CODE);

;// CONCATENATED MODULE: ./src/components/hooks/useZipCodeValidation.tsx






function useZipCodeValidation() {
    var ref = (0,react.useState)(""), zipCode = ref[0], setZipCode = ref[1];
    var ref1 = (0,react.useState)(""), city = ref1[0], setCity = ref1[1];
    var ref2 = (0,react.useState)(""), state = ref2[0], setState = ref2[1];
    var ref3 = (0,react.useState)(false), hasError = ref3[0], setHasError = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(seoSegmentationValidateZipCode, {
        variables: {
            input: {
                zipcode: zipCode
            }
        }
    }), 1), validateZipCode = ref4[0];
    var validate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var newZipCode, ref, ref1, response, res;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        newZipCode = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "";
                        setHasError(false);
                        setZipCode(newZipCode);
                        if (newZipCode.length < 5) {
                            setCity("");
                            setState("");
                            setHasError(false);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: zipCode,
                                    city: "",
                                    state: ""
                                })
                            ];
                        }
                        if (!(newZipCode.length === 5)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            validateZipCode({
                                variables: {
                                    input: {
                                        zipcode: newZipCode
                                    }
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        res = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.seoSegmentationValidateZipCode;
                        if ((res === null || res === void 0 ? void 0 : res.__typename) === "SEOValidateZipCodeSuccess") {
                            setCity(res === null || res === void 0 ? void 0 : res.city);
                            setState(res === null || res === void 0 ? void 0 : res.state);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: newZipCode,
                                    city: res === null || res === void 0 ? void 0 : res.city,
                                    state: res === null || res === void 0 ? void 0 : res.state
                                })
                            ];
                        }
                        if (newZipCode.length === 5 && (res === null || res === void 0 ? void 0 : (ref1 = res.error) === null || ref1 === void 0 ? void 0 : ref1.__typename) === "InvalidSEOZipCodeError") {
                            setCity("");
                            setState("");
                            setHasError(true);
                            return [
                                2,
                                Promise.resolve({
                                    zipCode: newZipCode,
                                    city: "",
                                    state: ""
                                })
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            Promise.resolve({
                                zipCode: zipCode,
                                city: city,
                                state: state
                            })
                        ];
                }
            });
        });
        return function validate() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        validate: validate,
        hasError: hasError
    };
}


/***/ }),

/***/ 42182:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/*
 * date conversion to one of the following example formats:
 * Apr 2023
 * April 2023
 * Apr 25, 2023
 * April 25, 2023
 * Apr 25th, 2023
 * April 25th, 2023
 */ // Add postfix like 3rd, 4th, 22nd to the date
var getOrdinalNum = function(n) {
    return n + (n > 0 ? [
        "th",
        "st",
        "nd",
        "rd"
    ][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
};
var dateMonthYearFormat = function(param) {
    var dateTime = param.dateTime, _useLongMonth = param.useLongMonth, useLongMonth = _useLongMonth === void 0 ? false : _useLongMonth, _useOrdinalDay = param.useOrdinalDay, useOrdinalDay = _useOrdinalDay === void 0 ? false : _useOrdinalDay, _useFullDate = param.useFullDate, useFullDate = _useFullDate === void 0 ? false : _useFullDate;
    var date = new Date(dateTime);
    var dayOftheMonth = useOrdinalDay ? "".concat(getOrdinalNum(date.getUTCDate())) : date.getUTCDate();
    var month = useLongMonth ? date.toLocaleString("en-US", {
        month: "long"
    }) : date.toLocaleString("en-US", {
        month: "short"
    });
    var year = date.getUTCFullYear();
    return useFullDate ? "".concat(month, " ").concat(dayOftheMonth, ", ").concat(year) : "".concat(month, " ").concat(year);
};
/* harmony default export */ __webpack_exports__["Z"] = (dateMonthYearFormat);


/***/ })

}]);